import React from 'react';
import { Button } from '@/components/ui/button';
import { Loader2 } from 'lucide-react';

interface FormActionsProps {
  onCancel: () => void;
  submitLabel: string;
  isSubmitting?: boolean;
  submittingLabel?: string;
  cancelLabel?: string;
  disabled?: boolean;
}

/**
 * Standard footer for create/edit forms across the app.
 * - Right-aligned on ≥sm, full-width stacked on mobile (primary on top via flex-col-reverse).
 * - Primary action on the right, Cancel on the left.
 */
const FormActions: React.FC<FormActionsProps> = ({
  onCancel,
  submitLabel,
  isSubmitting = false,
  submittingLabel,
  cancelLabel = 'Cancel',
  disabled = false,
}) => {
  return (
    <div className="flex flex-col-reverse sm:flex-row sm:justify-end gap-2 pt-2">
      <Button
        type="button"
        variant="outline"
        onClick={onCancel}
        disabled={isSubmitting}
        className="w-full sm:w-auto"
      >
        {cancelLabel}
      </Button>
      <Button
        type="submit"
        disabled={isSubmitting || disabled}
        className="w-full sm:w-auto"
      >
        {isSubmitting ? (
          <>
            <Loader2 className="mr-2 h-4 w-4 animate-spin" />
            {submittingLabel ?? 'Saving...'}
          </>
        ) : (
          submitLabel
        )}
      </Button>
    </div>
  );
};

export default FormActions;
